import { EOrderType } from 'views/types/transactions';
import { SortOrder, TransactionSortField } from 'views/types/typeTransaction';
import { create, useStore } from 'zustand';

interface SortState {
  sortBy: TransactionSortField | null;
  sortOrder: SortOrder | null;
}

interface IUserTxsTableStore {
  page: number;
  txType: EOrderType;
  searchBy: string;
  itemsPerPage: number;
  sortState: SortState;

  setPage: (page: number) => void;
  setTxType: (txType: EOrderType) => void;
  setSearchBy: (value: string) => void;
  setItemsPerPage: (count: number) => void;
  setSortState: (state: SortState) => void;
  resetFilters: () => void;
}

const defaultState = {
  page: 0,
  txType: EOrderType.ALL,
  searchBy: '',
  itemsPerPage: 10,
  sortState: {
    sortBy: null,
    sortOrder: null,
  } as SortState,
};

export const userTxsTableStore = create<IUserTxsTableStore>(set => ({
  ...defaultState,

  setPage: page => set({ page }),
  setTxType: txType => set({ txType }),
  setSearchBy: searchBy => set({ searchBy }),
  setItemsPerPage: itemsPerPage => set({ itemsPerPage }),
  setSortState: sortState => set({ sortState }),
  resetFilters: () => {
    set({ ...defaultState });

    sessionStorage.removeItem('startDate');
    sessionStorage.removeItem('endDate');
    sessionStorage.removeItem('currencyFilter');
    sessionStorage.removeItem('statusFilter');
  },
}));

export const useTransactionFilterStore = () => useStore(userTxsTableStore);
